const TipoUsuarioEnum = {
  ETHOS: 1,
  ADMIN: 2,
  NORMAL: 3,
}

export default TipoUsuarioEnum
